<div class="form-input-text-group-wrapper">
  <!-- LABEL -->
  <label [htmlFor]="id" [innerHTML]="label" class="input-label" *ngIf="label"></label>
  <!-- INPUT -->
  <p-inputgroup class="form-input-text-group"
    [ngClass]="{'pre': (pre && !preIcon) || (!pre && preIcon), 'pre-and-icon': pre && preIcon, 
      'post': post || postIcon}">
    <!-- pre -->
    <p-inputgroup-addon *ngIf="preIcon">
      <span [class]="preIcon" severity="secondary" variant="text"></span>
    </p-inputgroup-addon>
    <p-inputgroup-addon *ngIf="pre">
      <span severity="secondary" variant="text">{{ pre }}</span>
    </p-inputgroup-addon>
    <!-- text type -->
    <input pInputText [id]="id" (input)="onInput($event)" [value]="formControl['value']"
      [disabled]="formControl['disabled']" [ngClass]="{ 'disabled': formControl['disabled'] }" 
      [placeholder]="placeholder || ''" *ngIf="!number"/>
    <!-- number type -->
    <p-inputnumber [id]="id" inputId="integeronly" [(ngModel)]="formControl['value']" (ngModelChange)="onInput($event)"
      [disabled]="formControl['disabled']" [ngClass]="{ 'disabled': formControl['disabled'] }"
      [mode]="'decimal'" [minFractionDigits]="decimals" [maxFractionDigits]="decimals"
      [locale]="'es-ES'" [useGrouping]="true" [placeholder]="placeholder || ''" *ngIf="number"/>
    <!-- post -->
    <p-inputgroup-addon *ngIf="post || postIcon">
      <span [class]="postIcon" severity="secondary" variant="text">{{ post }}</span>
    </p-inputgroup-addon>
  </p-inputgroup>
  <!-- ERRORS -->
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
      [required]="formControl.errors?.['required']"
      [max]="formControl.errors?.['max']"
      [min]="formControl.errors?.['min']"
      [pattern]="formControl.errors?.['pattern']"></app-form-input-error>
</div>